import { Navigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AuthStatusScreen } from "@/components/auth/AuthStatusScreen";
import { LoginForm } from "@/components/login-form";
import { LanguageSwitcher } from "@/components/shared/LanguageSwitcher";
import { useAuth } from "@/contexts/AuthContext";

const ALLOWED_RETURN_PREFIXES = ["/accept-invitation"];

function getReturnTo(searchParams: URLSearchParams): string {
  const returnTo = searchParams.get("returnTo");
  if (!returnTo || typeof returnTo !== "string") return "/";
  const path = returnTo.startsWith("/") ? returnTo : `/${returnTo}`;
  const allowed = ALLOWED_RETURN_PREFIXES.some((prefix) =>
    path === prefix || path.startsWith(`${prefix}?`)
  );
  return allowed ? path : "/";
}

export function LoginPage(): JSX.Element {
  const [searchParams] = useSearchParams();
  const { isAuthenticated, isLoading } = useAuth();
  const { t } = useTranslation();
  const returnTo = getReturnTo(searchParams);

  if (isLoading) {
    return (
      <AuthStatusScreen
        state="loading"
        title={t("auth.session.checkingTitle", "Cargando")}
        message={t(
          "auth.session.checkingDetail",
          "Estamos verificando tu sesión.",
        )}
      />
    );
  }
  if (isAuthenticated) return <Navigate to={returnTo} replace />;
  return (
    <div className="fx-auth-stage">
      <div className="lang-switch">
        <LanguageSwitcher />
      </div>
      <LoginForm returnTo={returnTo} />
    </div>
  );
}
